import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';
import { OilFieldDto } from './oil-field.dto';


export class OilBlockDto extends EpimsBaseEntityDto {
	@IsNotEmpty() OilBlockId: string;
	@IsNotEmpty() OilBlockName: string;
	@IsNotEmpty() LabelName: string;
	oilFields?: OilFieldDto[];
}
